export default __webpack_public_path__ + "static/media/remeet-wepl-image1.abe94ac3.png";